import OnlyHeader from "components/Layout/OnlyHeader";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Container, Card, CardHeader, Col } from "reactstrap";

function Settings() {
  const { user, userPermissions } = useSelector((state) => state.auth);
  const settingsPermissions = userPermissions?.settings;

  const data = [
    {
      icon: "fas fa-user-cog",
      title: "Account Settings",
      link: "settings/account",
    },
    {
      icon: "fas fa-user-cog",
      title: "Client Settings",
      link: "settings/client-setting-menu",
    },
    {
      icon: "fas fa-user-cog",
      title: "Billing",
      link: "settings/billing",
    },
    {
      icon: "fas fa-user-cog",
      title: "Venue Settings",
      link: "settings/venue-setting-menu",
    },
  ];
  const history = useHistory();
  return (
    <>
      <OnlyHeader />
      <Container fluid className="mt--7">
        <div className="col">
          <Card className="shadow">
            <CardHeader className="d-lg-flex d-sm-block justify-content-between">
              <h3 className="mb-0 pt-2 ">Settings</h3>
            </CardHeader>

            <Container className="my-4">
              {user?.type === "kitchen-admin" ? (
                <>
                  {settingsPermissions?.get ? (
                    <Row className="pb-2">
                      {data?.map((el, id) => {
                        return (
                          <Col
                            key={id}
                            className="mt-2 d-flex justify-content-center"
                          >
                            <Card
                              className="shadow rounded d-flex justify-content-center align-items-center py-4 px-2 pointer"
                              style={{
                                width: "150px",
                              }}
                              onClick={() => {
                                history.push(`/admin/${el.link}`);
                              }}
                            >
                              <i className={`${el.icon} fa-2x `}></i>
                              <h4 className="mt-2 m-0">{el.title}</h4>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  ) : (
                    <Row className="py-4 justify-content-center align-items-center">
                      You don't have the permission to access the page
                    </Row>
                  )}
                </>
              ) : (
                <Row className="pb-2">
                  {data?.map((el, id) => {
                    return (
                      <Col
                        key={id}
                        className="mt-2 d-flex justify-content-center"
                      >
                        <Card
                          className="shadow rounded d-flex justify-content-center align-items-center py-4 px-2 pointer"
                          style={{ width: "200px", height: "180px" }}
                          onClick={() => {
                            history.push(`/admin/${el.link}`);
                          }}
                        >
                          <i className={`${el.icon} fa-2x `}></i>
                          <h4 className="mt-2 m-0">{el.title}</h4>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </Container>
          </Card>
        </div>
      </Container>
    </>
  );
}

export default Settings;
